import React, { useRef, useState } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import JoditEditor from "jodit-react";
import { Modal, Button, Form, Row, Col, Card } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const CreatePage = () => {
  const editor = useRef(null);
  const navigate = useNavigate();
  const [pageid, setPageId] = useState("");
  const [pageurlname, setPageUrlName] = useState("");
  const [pagename, setPageName] = useState("");
  const [pagetitle, setPageTitle] = useState("");
  const [pagesubtitle, setPageSubtitle] = useState("");
  const [pagetype, setPageType] = useState("");
  const [pagesubtype, setPageSubtype] = useState("");
  const [pagecontent, setPageContent] = useState("");
  const [pagetheme, setPageTheme] = useState("");
  const [tobeaddedinmenu, setToBeAddedInMenu] = useState("");
  const [tobeaddedinsubmenu1, setToBeAddedInSubmenu1] = useState("");
  const [parentofsubmenu1, setParentofSubmenu1] = useState("");
  const [tobeaddedinsubmenu2, setToBeAddedInSubmenu2] = useState("");
  const [parentofsubmenu2, setParentofSubmenu2] = useState("");
  const [iscommon, setIsCommon] = useState("");
  const [issecure, setIsSecure] = useState("");
  const [templateid, setTemplateId] = useState("");
  const [hasmenubar, setHasMenubar] = useState("");
  const [hasheader, setHasHeader] = useState("");
  const [hasfooter, setHasFooter] = useState("");
  const [hasleftsidebar, setHasLeftSidebar] = useState("");
  const [hasrightsidebar, setHasRightSidebar] = useState("");
  const [leftsidebarid, setLeftSidebarId] = useState("");
  const [rightsidebarid, setRightSidebarId] = useState("");
  const [isactive, setIsActive] = useState(1);


  const url = process.env.REACT_APP_API_URL;

  const [showCreateModal, setShowCreateModal] = useState(false);
  const [isExistingPage, setIsExistingPage] = useState(false);

  // --- Logic: Fetch Existing Data (Using fetchpagedata API) ---
  const handleFetchData = async () => {
    if (!pagename.trim()) {
      toast.warning("Please enter a Page Name first", { theme: "colored" });
      return;
    }
    try {
      const headers = { 'x-access-token': localStorage.getItem('jwttoken') };
      // API 1: Fetch specific page data by name
      const response = await axios.get(`${url}pages/fetchpagedata/${pagename}`, { headers });

      if (response.status === 200 && response.data.length > 0) {
        const data = response.data[0];
        setPageId(data.pageid || "");
        setPageUrlName(data.pageurlname || "");
        setPageTitle(data.pagetitle || "");
        setPageSubtitle(data.pagesubtitle || "");
        setPageContent(data.pagecontent || "");
        setPageType(data.pagetype || "");
        setPageSubtype(data.pagesubtype || "");
        setPageTheme(data.pagetheme || "");
        setTemplateId(data.templateid || 1);
        
        setIsExistingPage(true);
        toast.error("Page Name already exists! Loaded existing configuration.", { theme: "colored" });
      }
    } catch (err) {
      setIsExistingPage(false);
      toast.success("Page Name is available for registration.", { theme: "colored" });
    }
  };

const checkCategoryConflict = async () => {
    try {
        const headers = { 'x-access-token': localStorage.getItem('jwttoken') };
        // API 2: Fetch by type/subtype to see if this category is already populated
        await axios.post(`${url}pages/fetchpagecontent`, { pagetype, pagesubtype }, { headers });
        // If it succeeds, it means pages already exist in this category
        toast.info(`Note: Other pages already exist in ${pagetype}/${pagesubtype}`, { theme: "light" });
    } catch (err) {
        // No data found for this category, which is fine for a new creation
    }
  };

  const handleCreate = async () => {
    setShowCreateModal(false)
    if (isExistingPage) {
      toast.error("Duplicate Name. Please use a unique Page Name to create a new entry.", { theme: "colored" });
      return;
    }
   const pageData = {
      pageid, pageurlname, pagename, pagetitle, pagesubtitle, pagetype,
      pagesubtype, pagecontent, pagetheme, 
      tobeaddedinmenu: Number(tobeaddedinmenu), 
      tobeaddedinsubmenu1: Number(tobeaddedinsubmenu1),
      parentofsubmenu1: Number(parentofsubmenu1), 
      tobeaddedinsubmenu2: Number(tobeaddedinsubmenu2), 
      parentofsubmenu2: Number(parentofsubmenu2), 
      iscommon: Number(iscommon), 
      issecure: Number(issecure),
      templateid: Number(templateid), 
      hasmenubar: Number(hasmenubar), 
      hasheader: Number(hasheader), 
      hasfooter: Number(hasfooter), 
      hasleftsidebar: Number(hasleftsidebar),
      hasrightsidebar: Number(hasrightsidebar), 
      leftsidebarid: Number(leftsidebarid), 
      rightsidebarid: Number(rightsidebarid), 
      isactive: Number(isactive)
    };
  
    try {
        const headers = {
          'x-access-token': localStorage.getItem('jwttoken')
        };
        const response = await axios.post(
          url + "pages/addNewData",
          pageData, {headers}
        );

        if (response.status === 201 || response.status === 200) {
          toast.success("Page created successfully", {
            position: "top-right",
            autoClose: 1000,
            theme: "colored",
          });
          setTimeout(() => {
            navigate("/pages");
          }, 2000);
        }
      } catch (err) {
        toast.error("An error occurred while creating the page.", {
          position: "top-right",
          autoClose: 1000,
          theme: "colored",
        });
    }
  }
  const handleSubmit = async (e) => {
   e.preventDefault();
   if (isExistingPage) {
      toast.error("Duplicate found. Please fetch or change the Page Name.", { theme: "colored" });
      return;
    }
   setShowCreateModal(true);
  };

  return (
    <div className="container mt-4 mb-5">
      <ToastContainer position="top-right" autoClose={3000} theme="colored" />

      <Card className="form-card shadow-sm">
        <Card.Header className="form-card-header bg-primary text-white py-3">
          <h5 className="mb-0">Add New Page Configuration</h5>
        </Card.Header>

        <Card.Body className="form-card-body p-4">
          <Form onSubmit={handleSubmit}>
            <h6 className="text-primary border-bottom pb-2 mb-3">Basic Information</h6>
            <Row className="mb-3">
              <Form.Group as={Col} md={4} controlId="pagename">
                <Form.Label>Page Name:</Form.Label>
                <div className="d-flex gap-2">
                  <Form.Control 
                    type="text" 
                    value={pagename} 
                    onChange={(e) => {
                        setPageName(e.target.value);
                        setIsExistingPage(false); 
                    }} 
                    placeholder="Enter unique name"
                    required
                  />
                  <Button variant="primary" onClick={handleFetchData} size="sm">
                    Fetch
                  </Button>
                </div>
              </Form.Group>
              <Form.Group as={Col} md={4} controlId="pageid">
                <Form.Label>Page ID:</Form.Label>
                <Form.Control
                  type="text"
                  value={pageid}
                  onChange={(e) => setPageId(e.target.value)}
                  placeholder="Enter ID"
                  required
                />
              </Form.Group>
              <Form.Group as={Col} md={4} controlId="pageurlname">
                <Form.Label>URL Name:</Form.Label>
                <Form.Control 
                    type="text" 
                    value={pageurlname} 
                    onChange={(e) => setPageUrlName(e.target.value)} 
                    required
                />
              </Form.Group>
            </Row>

            <Row className="mb-3">
              <Form.Group as={Col} md={6} controlId="pagetitle">
                <Form.Label>Page Title:</Form.Label>
                <Form.Control type="text" value={pagetitle} onChange={(e) => setPageTitle(e.target.value)} />
              </Form.Group>
              <Form.Group as={Col} md={6} controlId="pagesubtitle">
                <Form.Label>Page Sub-Title:</Form.Label>
                <Form.Control type="text" value={pagesubtitle} onChange={(e) => setPageSubtitle(e.target.value)} />
              </Form.Group>
            </Row>

            <Row className="mb-4">
              <Form.Group as={Col} md={3} controlId="pagetype">
                <Form.Label>Page Type:</Form.Label>
                <Form.Control 
                    type="text" 
                    value={pagetype} 
                    onChange={(e) => setPageType(e.target.value)} 
                    onBlur={checkCategoryConflict} // Uses API 2 to inform admin
                />
              </Form.Group>
              <Form.Group as={Col} md={3} controlId="pagesubtype">
                <Form.Label>Sub Type:</Form.Label>
                <Form.Control 
                    type="text" 
                    value={pagesubtype} 
                    onChange={(e) => setPageSubtype(e.target.value)} 
                    onBlur={checkCategoryConflict} // Uses API 2 to inform admin
                />
              </Form.Group>
              <Form.Group as={Col} md={3} controlId="pagetheme">
                <Form.Label>Theme:</Form.Label>
                <Form.Control type="text" value={pagetheme} onChange={(e) => setPageTheme(e.target.value)} />
              </Form.Group>
              <Form.Group as={Col} md={3} controlId="templateid">
                <Form.Label>Template ID:</Form.Label>
                <Form.Control type="number" value={templateid} onChange={(e) => setTemplateId(e.target.value)} />
              </Form.Group>
            </Row>

            <h6 className="text-primary border-bottom pb-2 mb-3 mt-4">Menu & Navigation</h6>
            <Row className="mb-3">
              <Form.Group as={Col} md={4} controlId="tobeaddedinmenu">
                <Form.Label>Add to Menu (0/1):</Form.Label>
                <Form.Control type="number" value={tobeaddedinmenu} onChange={(e) => setToBeAddedInMenu(e.target.value)} />
              </Form.Group>
              <Form.Group as={Col} md={4} controlId="iscommon">
                <Form.Label>Is Common (0/1):</Form.Label>
                <Form.Control type="number" value={iscommon} onChange={(e) => setIsCommon(e.target.value)} />
              </Form.Group>
              <Form.Group as={Col} md={4} controlId="issecure">
                <Form.Label>Is Secure (0/1):</Form.Label>
                <Form.Control type="number" value={issecure} onChange={(e) => setIsSecure(e.target.value)} />
              </Form.Group>
            </Row>

            <h6 className="text-primary border-bottom pb-2 mb-3 mt-4">Layout Settings</h6>
            <Row className="mb-3 text-center">
              <Form.Group as={Col}><Form.Label>Header</Form.Label><Form.Control type="number" value={hasheader} onChange={(e) => setHasHeader(e.target.value)} /></Form.Group>
              <Form.Group as={Col}><Form.Label>Menubar</Form.Label><Form.Control type="number" value={hasmenubar} onChange={(e) => setHasMenubar(e.target.value)} /></Form.Group>
              <Form.Group as={Col}><Form.Label>L-Sidebar</Form.Label><Form.Control type="number" value={hasleftsidebar} onChange={(e) => setHasLeftSidebar(e.target.value)} /></Form.Group>
              <Form.Group as={Col}><Form.Label>R-Sidebar</Form.Label><Form.Control type="number" value={hasrightsidebar} onChange={(e) => setHasRightSidebar(e.target.value)} /></Form.Group>
              <Form.Group as={Col}><Form.Label>Footer</Form.Label><Form.Control type="number" value={hasfooter} onChange={(e) => setHasFooter(e.target.value)} /></Form.Group>
            </Row>

            <Form.Group className="mb-4" controlId="pagecontent">
              <Form.Label className="fw-bold">Page Content:</Form.Label>
              <JoditEditor
                ref={editor}
                value={pagecontent}
                onBlur={(newContent) => setPageContent(newContent)}
              />
            </Form.Group>

            <div className="form-actions mt-4">
                <button type="submit" className="btn-gradient-primary">
                Add Page
                </button>
                <Link to="/pages" className="btn-back-link ms-3 text-decoration-none text-muted">
                  ← Back to List
                </Link>
            </div>
          </Form>
        </Card.Body>
      </Card>

      <Modal show={showCreateModal} onHide={() => setShowCreateModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>Confirm Creation</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Are you sure you want to create this new page configuration?
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowCreateModal(false)}>
              Cancel
            </Button>
            <Button type="button" onClick={handleCreate} variant="primary">
              Create
            </Button>
          </Modal.Footer>
      </Modal>
    </div>
  );
};

export default CreatePage;